import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  // your theme configuration
});

export default theme;
